import { render, staticRenderFns } from "./ProductRestockModal.vue?vue&type=template&id=f6d82ec2&scoped=true&"
import script from "./ProductRestockModal.vue?vue&type=script&lang=js&"
export * from "./ProductRestockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d82ec2",
  null
  
)

export default component.exports